import { call, put, select } from 'redux-saga/effects';
import {
  initFinancedPayment as initFinancedPaymentAda,
} from '@bitComponents/adabyron/payment';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* initFinancedPayment(params) {
  const {
    normalizeHttpErrors,
    reduxUpdate,
  } = params;
  try {
    const context = yield select(contextStore);
    const response = yield call(initFinancedPaymentAda, params, context);
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.INIT_FUNDED_PAYMENT, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
